import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import {Link} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import {useHistory} from 'react-router';
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import {date_format, datetime_format} from "../Common/DateFormat";

import {API_URL} from '../constants.js';

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {useTranslation} from "react-i18next";

export function TransactionList(props) {
    const { t } = useTranslation();
    const transactionType = props.match.params.type.toLowerCase();
    const transactionTypeTitle = transactionType.charAt(0).toUpperCase() + transactionType.slice(1);
    const [transactions, setTransactions] = useState([]);
    const [transaction, setTransaction] = useState(-1);
    const [show, setShow] = useState(false);
    const history = useHistory();
    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);

    const setCurrentTransaction = (transaction) => {
        setTransaction(transaction);
        setShow(true);

    };

    const handleClose = () => setShow(false);

    const deleteTransaction = () => {
        setDisabled(1);
        setIconDisabled(0);
        axios.post(
            API_URL + 'transaction/' + transaction.id + '/delete'
        ).then((response) => {
            if (response.data?.status === true) {
                history.go(0);
                setShow(false);
                alertify.success(response.data.message);
            } else {
                setDisabled(0);
                setIconDisabled(1);
                alertify.error(response.data?.message || "Something went wrong. Try again!");
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            alertify.error(error.response?.data?.message || "Something went wrong. Try again!");
        });
    }

    useEffect(() => {

        axios.get(API_URL + 'transaction/'+ transactionType).then((response) => {
            if ($.fn.DataTable.isDataTable("#transaction_table")) {
                $("#transaction_table").DataTable().destroy();
            }

            if (response.data?.status === true) {
                const transactionRows = Array.isArray(response.data?.data) ? response.data.data : [];
                setTransactions(transactionRows);

                if (transactionRows.length > 0) {
                    setTimeout(() => {
                        if ($.fn.DataTable.isDataTable("#transaction_table")) {
                            $("#transaction_table").DataTable().destroy();
                        }
                        $("#transaction_table").DataTable();
                    }, 0);
                }
            } else {
                setTransactions([]);
                alertify.error(response.data?.message || "Something went wrong. Try again!");
                return null;
            }
        }).catch((error) => {
            setTransactions([]);
            alertify.error(error.response?.data?.message || "Something went wrong. Try again!");
        });

        return () => {
            if ($.fn.DataTable.isDataTable("#transaction_table")) {
                $("#transaction_table").DataTable().destroy();
            }
        }
    }, [transactionType]);


    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title={`${transactionTypeTitle}  List`}>
                            <CardHeaderToolbar>
                                <Link to={`/transaction/create/`+transactionType} className="btn btn-primary btn-sm mx-3">
                                    {t("Create")} {transactionTypeTitle}
                                </Link>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody style={{overflow:'auto'}}>

                            <table id="transaction_table" className="stratprop_datatable table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>{t("SN.")}</th>
                                    <th>{t("Date")}</th>
                                    <th>{t("Amount")}</th>
                                    <th>{t("Notes")}</th>
                                    <th>{transactionTypeTitle} {t("Category")}</th>
                                    <th>{t("Actions")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {transactions.length > 0 ? (
                                    transactions.map((transaction, index) => (
                                        <tr key={transaction.id}>
                                            <td>{index + 1}</td>
                                            <td>{transaction.date}</td>
                                            <td>{transaction.amount}</td>
                                            <td>{transaction.notes}</td>
                                            <td>{transaction.transaction_category?.name || "-"}</td>
                                            <td>
                                                <Link to={`/transaction/edit/${transaction.id}/${transactionType}`}
                                                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
                                                    <span className="svg-icon svg-icon-md svg-icon-primary">
                                                          <SVG
                                                              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                          />
                                                    </span>
                                                </Link>
                                                <a
                                                    onClick={() => setCurrentTransaction(transaction)}
                                                    key={transaction.id}
                                                    className="btn btn-icon btn-light btn-hover-danger btn-sm">
                                                    <span className="svg-icon svg-icon-md svg-icon-danger">
                                                      <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>
                                                    </span>
                                                </a>

                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={"6"}>{t("No Transaction")}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Delete Transaction")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("Are you sure you want to Delete?")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("Close")}
                    </Button>
                    <Button variant="primary" onClick={deleteTransaction} disabled={disabled}>
                        {t("Confirm")}
                        <span
                            dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
